import React from "react";
import {
  Box,
  Button,
  Grid,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import {
  Comment,
  ErrorOutline,
} from "@mui/icons-material";
import { formatDateWithTime } from "../../helpers";
import { IAcitvityCommentsLogsProps } from "./Activity.types";
import { ERROR_MESSAGES } from "../../constants/enums";
import { useDispatchWrapper } from "../../hooks";


import { IComment } from "../../redux/comments/commentsTypes";
import { fetchCommentsAysnc, upsertCommentAysnc } from "../../redux/comments/commentsActions";
import { CustomTextField } from "../formsComponents";
import { useFormik } from "formik";

export const ActivityCommentsLogs: React.FC<IAcitvityCommentsLogsProps> = (props) => {
  const { moduleInformation } = props;
  const [comments, setComments] = React.useState<IComment[]>([]);
  const [loading, setLoading] = React.useState(false);

  const theme = useTheme();
  const [openEmail, setOpenEmail] = React.useState(false);
  const [openTask, setOpentask] = React.useState(false);
  const dispatch = useDispatchWrapper();

  const { values, handleChange, handleSubmit,resetForm } = useFormik({
    initialValues: {
      comment: "",
    },
    onSubmit: (values) => {

      dispatch(
        upsertCommentAysnc(
          {
            comment: values.comment,
            comment_type: "",
            incremental_number: null,
            status: "ACTIVE",
            type_id: moduleInformation.moduleId,
            first_name: "",
            insert_ts: "",
            last_name: "",
          },
          {
            comment: "",
            comment_type: "",
            incremental_number: null,
            status: "",
            first_name: "",
            insert_ts: "",
            last_name: "",
            type_id: "",
          }, false,
          (isSuccess) => {
            if (isSuccess) {
                resetForm()
              fetchComments();
            }
          }
        )
      );
    },
  });

  const fetchComments = async () => {
    setLoading(true);
    dispatch(
      fetchCommentsAysnc(moduleInformation.moduleId, (isSuccess, data) => {
        if (isSuccess && data) {
          setComments(data);
        }
        setLoading(false);
      })
    );
  };

  React.useEffect(() => {
    fetchComments();
  }, []);



  return (
    <>
      <Stack mt={3}>
        <Stack
          padding={1}
          sx={{
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
          }}
        >
          <Typography variant="h5" fontWeight={600}>
            Logs
          </Typography>
        </Stack>
        <Stack direction={"column"} spacing={1} mt={3}>
          {loading && (
            <>
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
            </>
          )}
           {!loading  && comments.length === 0 && (
              <>
              <Box minHeight={100} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
               <Box display={'flex'} justifyContent={'center'} mb={1}>
                 <ErrorOutline/>
               </Box>
             <Box display={'flex'} justifyContent={'center'} width={'80%'}>
             <Typography variant="body1" textAlign={'center'} fontWeight={600}>{ERROR_MESSAGES.NO_RECORD_FOUND}</Typography>
             </Box>
              </Box>
           </>
          )}

          {comments.map((item, index) => {
            return <Row key={index} comment={item} />;
          })}
           
        </Stack>
        <Box mt={6}>
           <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={10}>
              <CustomTextField
                fullWidth
                id="comment"
                value={values.comment}
                sx={{ background: "#fff" }}
               onChange={handleChange}
                placeholder="Type comment...."
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                variant="contained"
                fullWidth
                size="small"
               
                type="submit"
                // disabled={saveLoading}
              >
                Send
              </Button>
            </Grid>
          </Grid>
        </form>
           </Box>
      </Stack>
    </>
  );
};

const Row: React.FC<{ comment: IComment }> = ({ comment }) => {
  const theme = useTheme();

  const colors = {
    High: "error",
    Medium: "warning",
    Low: "success",
  };
  return (
    <Stack position={"relative"} minHeight={"80px"}>
      <Stack
        direction={"row"}
        spacing={1.5}
        sx={{
         ":before": {
            content: "''",
            height: "100%",
            width: "2px",
            position: "absolute",
            left: "18px", // <-- fixed position for vertical line
            top: 0,
            bottom: 0,
            zIndex: 0,
            backgroundColor: theme.palette.error.main,
          },
        }}
      >
        <Box
          border={"1px solid #fff"}
          sx={{ backgroundColor: "#fff" }}
          zIndex={1}
          height={"fit-content"}
        >
          <Comment color="error" fontSize="large" />
        </Box>
        <Stack width={"100%"}>
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              variant="body1"
              fontSize={"1.1rem"}
              color={"error"}
              maxWidth={"55%"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
              whiteSpace={"nowrap"}
              fontWeight={600}
            >
              {comment.first_name+" "+comment.last_name}
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formatDateWithTime(comment.insert_ts)}
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="body1" fontWeight={500}>
             {comment.comment}
            </Typography>
         
          </Stack>
          {/* <Typography variant="body1" fontWeight={500}>
            Created By : <span style={{marginLeft: 2}}>{task.craeted_by_name}</span>
          </Typography> */}
        </Stack>
      </Stack>
    </Stack>
  );
};
